export const SITE_URL = "https://www.alexrodriguez.com.au";

export const ORGANIZATION_NAME = "Alex Rodriguez Counselling, Life Coaching & Allied Health";

// Google truncates title tags in the SERP past ~60 characters. Content titles
// (blog posts, podcast episodes) come from WordPress and can already be long,
// so only append the brand suffix when it still fits - otherwise the bare
// title (already unique and descriptive) is used as-is.
const TITLE_SUFFIX = " - Alex Rodriguez";
const MAX_TITLE_LENGTH = 60;

export const buildPageTitle = (title: string): string => {
  const withSuffix = `${title}${TITLE_SUFFIX}`;
  return withSuffix.length <= MAX_TITLE_LENGTH ? withSuffix : title;
};

// Social Media
export const SOCIAL_LINKS = {
  twitter: "@alexrodriguez",
  facebook: "https://facebook.com/alexrodriguez",
  linkedin: "https://linkedin.com/in/alexrodriguez",
  instagram: "https://instagram.com/alexrodriguez",
} as const;

// Logo and Branding Assets
export const metaAssets = {
  icons: {
    icon16: "/meta/16x16.png",
    icon32: "/meta/32x32.png",
    icon150: "/meta/150x150.png",
    icon167: "/meta/167x167.png",
    icon180: "/meta/180x180.png",
    icon192: "/meta/192x192.png",
    icon512: "/meta/512x512.png",
  },

  // Open Graph Images (for social media sharing)
  openGraph: {
    default: "/meta/1200x630.png", // Standard OG image (1200x630)
    square: "/meta/1200x1200.png", // Square format (1200x1200)
    twitter: "/meta/1200x600.png", // Twitter card (1200x600)
  },

  // Apple Touch Icons
  appleTouchIcon: "/meta/180x180.png",

  // Android Chrome Icons
  androidChrome192: "/meta/192x192.png",
  androidChrome512: "/meta/512x512.png",
} as const;

// layout

// export const metadataExampleForLayout = {
//   metadataBase: new URL(""),
//   title: "",
//   description: "",
//   manifest: "/manifest.json",
//   alternates: {
//     canonical: "",
//   },
//   keywords: [],
//   openGraph: {
//     title: "",
//     description: "",
//     url: "",
//     siteName: "",
//     images: "fromConstantmetaAssets",
//     locale: "en-US",
//     type: "website",
//   },
//   twitter: {
//     title: "",
//     card: "summary_large_image",
//     description: "",
//     images: "fromConstantmetaAssets",
//   },
//   robots: {
//     index: true,
//     follow: true,
//     nocache: false,
//     googleBot: {
//       index: true,
//       follow: true,
//       "max-snippet": -1,
//       "max-image-preview": "large",
//       "max-video-preview": -1,
//     },
//   },
// };

// // static page

// export const metadataExampleForStatic = {
//   title: "",
//   description: "",
//   alternates: {
//     canonical: "",
//   },
//   openGraph: {
//     title: "",
//     description: "",
//     url: "",
//     siteName: "",
//     images: "fromConstantmetaAssets",
//     locale: "en-US",
//     type: "website",
//   },
//   twitter: {
//     title: "",
//     card: "summary_large_image",
//     description: "",
//     images: "fromConstantmetaAssets",
//   },
// };
